<div class="container-fluid">
  <div class="row">
    <aside class="app-sidebar col-2 d-none d-md-flex flex-column position-fixed py-2 primary-bg">
      <div class="mb-auto">
        <a routerLink="/dashboard" class="d-flex justify-content-center my-5 py-3">
          <img class="app-layout-logo" src="../../../assets/white_text_logo.png" alt="logo"/>
        </a>

        <ul class="nav nav-pills flex-column">
          <li class="nav-item">
            <a class="nav-link app-sidebar-link d-flex flex-nowrap" routerLink="/dashboard" routerLinkActive="active">
              <fa-icon class="me-3" [fixedWidth]="true" size="xl" [icon]="faHome"/>
              <span class="d-none d-md-inline fw-bold">Почетна</span>
            </a>
          </li>

          <li class="nav-item mt-2">
            <a class="nav-link app-sidebar-link d-flex flex-nowrap" routerLink="/orders" routerLinkActive="active">
              <fa-icon class="me-3" [fixedWidth]="true" size="xl" [icon]="faListAlt"/>
              <span class="d-none d-md-inline fw-bold">Налози</span>
            </a>
          </li>

          <li class="nav-item mt-2">
            <a class="nav-link app-sidebar-link d-flex flex-nowrap" routerLink="/files" routerLinkActive="active">
              <fa-icon class="me-3" [fixedWidth]="true" size="xl" [icon]="faFolderOpen"/>
              <span class="d-none d-md-inline fw-bold">Датотеки</span>
            </a>
          </li>

          <li class="nav-item mt-2">
            <a class="nav-link app-sidebar-link d-flex flex-nowrap" routerLink="/settings" routerLinkActive="active">
              <fa-icon class="me-3" [fixedWidth]="true" size="xl" [icon]="faGear"/>
              <span class="d-none d-md-inline fw-bold">Поставки</span>
            </a>
          </li>
        </ul>
      </div>

      <hr class="text-white"/>

      <div class="dropdown p-2">
        <button
          type="button"
          class="btn app-user-menu-button d-flex text-wrap align-items-center text-white dropdown-toggle w-100"
          id="dropdownUserDesktop"
          data-bs-toggle="dropdown"
          aria-expanded="false">
          <fa-icon class="me-3" [fixedWidth]="true" size="xl" [icon]="faUserCircle"/>
          <strong class="col text-start">{{ email }}</strong>
        </button>
        <ul class="dropdown-menu app-dropdown-menu app-dropdown-primary text-small shadow" aria-labelledby="dropdownUserDesktop">
          <li>
            <a class="dropdown-item d-flex flex-nowrap" routerLink="/settings">
              <fa-icon class="me-2" [fixedWidth]="true" [icon]="faGear"/>
              <span>Поставки</span>
            </a>
          </li>
          <li><hr class="dropdown-divider"/></li>
          <li>
            <button type="button" class="dropdown-item d-flex flex-nowrap" (click)="logout()">
              <fa-icon class="me-2" [fixedWidth]="true" [icon]="faRightFromBracket"/>
              <span>Одјави се</span>
            </button>
          </li>
        </ul>
      </div>
    </aside>

    <nav class="app-mobile-navbar d-md-none navbar navbar-dark primary-bg fixed-top mb-5 shadow-sm">
      <div class="container-fluid d-flex position-relative flex-nowrap py-1">
        <button
          class="navbar-toggler app-navbar-toggler position-absolute ms-3"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasNavbar"
          aria-controls="offcanvasNavbar"
          aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="d-flex justify-content-center flex-grow-1">
          <a class="navbar-brand text-center" routerLink="/dashboard">
            <img class="app-mobile-logo" src="../../../assets/white_text_logo.png" alt="logo"/>
          </a>
        </div>

        <app-notification-center [mobile]="true" />
        <div class="offcanvas offcanvas-start app-mobile-drawer" tabindex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
          <div class="offcanvas-header">
            <button type="button" class="btn-close ms-auto" data-bs-dismiss="offcanvas" aria-label="Close"></button>
          </div>

          <div class="offcanvas-body d-flex flex-column justify-content-between">
            <ul class="navbar-nav nav-pills justify-content-end pe-3">
              <li class="nav-item">
                <a class="nav-link app-mobile-link d-flex flex-row" routerLink="/dashboard" routerLinkActive="active" data-bs-dismiss="offcanvas">
                  <fa-icon class="me-3" [fixedWidth]="true" size="xl" [icon]="faHome"/>
                  <span class="fw-bold">Почетна</span>
                </a>
              </li>

              <li class="nav-item mt-2">
                <a class="nav-link app-mobile-link d-flex flex-row" routerLink="/orders" routerLinkActive="active" data-bs-dismiss="offcanvas">
                  <fa-icon class="me-3" [fixedWidth]="true" size="xl" [icon]="faListAlt"/>
                  <span class="fw-bold">Налози</span>
                </a>
              </li>

              <li class="nav-item mt-2">
                <a class="nav-link app-mobile-link d-flex flex-row" routerLink="/files" routerLinkActive="active" data-bs-dismiss="offcanvas">
                  <fa-icon class="me-3" [fixedWidth]="true" size="xl" [icon]="faFolderOpen"/>
                  <span class="fw-bold">Датотеки</span>
                </a>
              </li>

              <li class="nav-item mt-2">
                <a class="nav-link app-mobile-link d-flex flex-row" routerLink="/settings" routerLinkActive="active" data-bs-dismiss="offcanvas">
                  <fa-icon class="me-3" [fixedWidth]="true" size="xl" [icon]="faGear"/>
                  <span class="fw-bold">Поставки</span>
                </a>
              </li>
            </ul>

            <div>
              <hr class="primary-color"/>
              <div class="dropup pe-3">
                <button
                  type="button"
                  class="btn app-user-menu-button primary-color d-flex text-wrap align-items-center dropdown-toggle w-100"
                  id="dropdownUserMobile"
                  data-bs-toggle="dropdown"
                  aria-expanded="false">
                  <fa-icon class="me-3" [fixedWidth]="true" size="xl" [icon]="faUserCircle"/>
                  <strong class="col text-start">{{ email }}</strong>
                </button>
                <ul class="dropdown-menu app-dropdown-menu app-dropdown-primary text-small shadow" aria-labelledby="dropdownUserMobile">
                  <li>
                    <a class="dropdown-item d-flex flex-nowrap" routerLink="/settings" data-bs-dismiss="offcanvas">
                      <fa-icon class="me-3" [fixedWidth]="true" [icon]="faGear"/>
                      <span>Поставки</span>
                    </a>
                  </li>
                  <li><hr class="dropdown-divider"/></li>
                  <li>
                    <button type="button" class="dropdown-item d-flex flex-nowrap" (click)="logout()">
                      <fa-icon class="me-3" [fixedWidth]="true" [icon]="faRightFromBracket"/>
                      <span>Одјави се</span>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>

    <div class="app-content col-md-10 col-sm-12 offset-md-2 container p-3 p-md-5 pt-5">
      <main role="main" class="pb-3">
        <router-outlet></router-outlet>
      </main>
    </div>
  </div>
</div>

<app-notification-center class="d-none d-md-block" />
